import { useState, useEffect, useCallback } from "react";
import { Plus, Trash2, UserCheck, CheckCircle } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function PersoneelTab({ token }) {
  const [personeel, setPersoneel] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toonForm, setToonForm] = useState(false);
  const [naam, setNaam] = useState("");
  const [email, setEmail] = useState("");
  const [wachtwoord, setWachtwoord] = useState("");
  const [opslaan, setOpslaan] = useState(false);
  const [fout, setFout] = useState("");
  const [succes, setSucces] = useState("");

  const laadPersoneel = useCallback(() => {
    fetch(`${API}/api/company/personeel`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.json())
      .then(d => { setPersoneel(d.personeel || []); setLoading(false); })
      .catch(() => setLoading(false));
  }, [token]);

  useEffect(() => { laadPersoneel(); }, [laadPersoneel]);

  const maakTrainerAan = async (e) => {
    e.preventDefault();
    if (!naam || !email || !wachtwoord) { setFout("Alle velden zijn verplicht"); return; }
    if (wachtwoord.length < 8) { setFout("Wachtwoord minimaal 8 tekens"); return; }
    setOpslaan(true); setFout("");
    try {
      const r = await fetch(`${API}/api/company/personeel`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ naam, email, password: wachtwoord }),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.detail || "Aanmaken mislukt");
      setSucces(`${naam} is als trainer toegevoegd!`);
      setNaam(""); setEmail(""); setWachtwoord(""); setToonForm(false);
      laadPersoneel();
      setTimeout(() => setSucces(""), 4000);
    } catch (err) { setFout(err.message); }
    finally { setOpslaan(false); }
  };

  const verwijderTrainer = async (id, trainerNaam) => {
    if (!window.confirm(`Weet je zeker dat je ${trainerNaam} wilt verwijderen?`)) return;
    await fetch(`${API}/api/company/personeel/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${token}` },
    });
    laadPersoneel();
  };

  return (
    <div className="max-w-2xl">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-white font-black text-xl">Personeel</h2>
          <p className="text-zinc-500 text-sm">Trainers die schema's maken en sporters begeleiden</p>
        </div>
        <button data-testid="trainer-toevoegen-btn" onClick={() => setToonForm(!toonForm)}
          className="flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-bold text-black"
          style={{ background: "#C9A84C" }}>
          <Plus size={14} /> Trainer toevoegen
        </button>
      </div>

      {succes && (
        <div className="mb-4 p-3 rounded-xl bg-green-500/10 border border-green-500/20 text-green-400 text-sm flex items-center gap-2">
          <CheckCircle size={14} /> {succes}
        </div>
      )}

      {toonForm && (
        <form onSubmit={maakTrainerAan} className="bg-[#111] border border-white/8 rounded-2xl p-5 mb-6">
          <h3 className="text-white font-bold mb-4">Nieuwe trainer</h3>
          {fout && <div className="mb-3 p-2.5 rounded-xl bg-red-500/10 border border-red-500/20 text-red-400 text-xs">{fout}</div>}
          <div className="space-y-3">
            <div>
              <label className="text-zinc-500 text-xs font-semibold uppercase tracking-wide block mb-1">Naam</label>
              <input value={naam} onChange={e => setNaam(e.target.value)} placeholder="Jan de Trainer" data-testid="trainer-naam-input"
                className="w-full bg-[#1a1a1a] border border-white/8 rounded-xl px-4 py-3 text-white text-sm focus:outline-none focus:border-white/20 autofill:bg-[#1a1a1a] [&:-webkit-autofill]:![box-shadow:0_0_0_1000px_#1a1a1a_inset] [&:-webkit-autofill]:[text-fill-color:white]" />
            </div>
            <div>
              <label className="text-zinc-500 text-xs font-semibold uppercase tracking-wide block mb-1">E-mailadres</label>
              <input value={email} onChange={e => setEmail(e.target.value)} placeholder="jan@sportschool.nl" type="email" data-testid="trainer-email-input"
                className="w-full bg-[#1a1a1a] border border-white/8 rounded-xl px-4 py-3 text-white text-sm focus:outline-none focus:border-white/20 [&:-webkit-autofill]:![box-shadow:0_0_0_1000px_#1a1a1a_inset] [&:-webkit-autofill]:[text-fill-color:white]" />
            </div>
            <div>
              <label className="text-zinc-500 text-xs font-semibold uppercase tracking-wide block mb-1">Wachtwoord</label>
              <input value={wachtwoord} onChange={e => setWachtwoord(e.target.value)} placeholder="Minimaal 8 tekens" type="password" data-testid="trainer-wachtwoord-input"
                className="w-full bg-[#1a1a1a] border border-white/8 rounded-xl px-4 py-3 text-white text-sm focus:outline-none focus:border-white/20 [&:-webkit-autofill]:![box-shadow:0_0_0_1000px_#1a1a1a_inset] [&:-webkit-autofill]:[text-fill-color:white]" />
            </div>
          </div>
          <div className="flex gap-2 mt-4">
            <button type="button" onClick={() => { setToonForm(false); setFout(""); }}
              className="flex-1 py-3 rounded-xl text-zinc-400 text-sm font-semibold border border-white/8 hover:bg-white/5">Annuleren</button>
            <button type="submit" disabled={opslaan} data-testid="trainer-opslaan-btn"
              className="flex-1 py-3 rounded-xl text-black text-sm font-bold disabled:opacity-50" style={{ background: "#C9A84C" }}>
              {opslaan ? "Aanmaken..." : "Trainer aanmaken"}
            </button>
          </div>
        </form>
      )}

      {loading ? (
        <div className="space-y-3">{[...Array(3)].map((_, i) => <div key={i} className="h-20 rounded-2xl bg-white/3 animate-pulse" />)}</div>
      ) : personeel.length === 0 ? (
        <div className="text-center py-16 border border-white/5 rounded-2xl">
          <UserCheck size={40} className="text-zinc-700 mx-auto mb-4" />
          <p className="text-zinc-400 font-semibold">Nog geen trainers aangemeld</p>
          <p className="text-zinc-600 text-sm mt-1">Voeg trainers toe zodat ze sporters kunnen begeleiden.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {personeel.map(t => (
            <div key={t.id} data-testid={`trainer-rij-${t.id}`}
              className="flex items-center gap-4 p-4 bg-[#111] border border-white/8 rounded-2xl">
              <div className="w-11 h-11 rounded-xl bg-[#C9A84C]/20 flex items-center justify-center text-sm font-black text-[#C9A84C] shrink-0">
                {(t.naam || "T")[0].toUpperCase()}
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-white font-bold text-sm">{t.naam}</p>
                <p className="text-zinc-600 text-xs truncate">{t.email}</p>
              </div>
              <div className="flex items-center gap-2">
                <span className="text-xs px-2.5 py-1 rounded-full font-semibold" style={{ background: "#C9A84C15", color: "#C9A84C" }}>Trainer</span>
                <button onClick={() => verwijderTrainer(t.id, t.naam)} data-testid={`trainer-verwijder-${t.id}`}
                  className="w-8 h-8 rounded-lg bg-red-500/10 flex items-center justify-center text-red-400 hover:bg-red-500/20">
                  <Trash2 size={13} />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
